<template>
  <div id="wrapper" class="font-fira">
    <TextHeader :headerTitle="$t('madrigalForBabies.title')" />
    <div id="content" class="w-container">
      <div id="intro">
        <p class="paragraph-1" v-html="$t('madrigalForBabies.p1')" />
        <p class="font-weight-bold" v-html="$t('madrigalForBabies.p2')" />
        <p class="font-weight-bold" v-html="$t('madrigalForBabies.p3')" />
        <img src="../assets/images/madrigal-for-babies/babies_01.jpg" alt="Image with the choir singing"/>
        <p v-html="$t('madrigalForBabies.p4')" />
        <p v-html="$t('madrigalForBabies.p5')" />
        <p v-html="$t('madrigalForBabies.p6')" />
        <p v-html="$t('madrigalForBabies.p7')" />
        <p v-html="$t('madrigalForBabies.p8')" />
      </div>
      <div id="studies">
        <p class="section-heading" v-html="$t('madrigalForBabies.p9')" />
        <div class="underline-bar"></div>
        <p v-html="$t('madrigalForBabies.p10')" />
        <ul>
            <li v-html="$t('madrigalForBabies.p11')" />
            <li v-html="$t('madrigalForBabies.p12')" />
            <li v-html="$t('madrigalForBabies.p13')" />
            <li v-html="$t('madrigalForBabies.p14')" />
        </ul>
        <img src="../assets/images/madrigal-for-babies/babies_02.jpg" alt="Image with the choir singing"/>
        <p class="font-weight-bold" v-html="$t('madrigalForBabies.p15')" />
        <p v-html="$t('madrigalForBabies.p16')" />
        <p v-html="$t('madrigalForBabies.p17')" />
        <p v-html="$t('madrigalForBabies.p18')" />
      </div>
      <div id="songs">
        <p class="section-heading" v-html="$t('madrigalForBabies.p21')" />
        <div class="underline-bar"></div>
        <ul>
            <li class="font-weight-bold" v-html="$t('madrigalForBabies.p22')" />
        </ul>
        <p v-html="$t('madrigalForBabies.p23')" />
        <p v-html="$t('madrigalForBabies.p24')" />
        <ul>
            <li class="font-weight-bold mt-4" v-html="$t('madrigalForBabies.p25')" />
        </ul>
        <p v-html="$t('madrigalForBabies.p26')" />
        <p v-html="$t('madrigalForBabies.p27')" />
        <ul>
            <li class="font-weight-bold mt-4" v-html="$t('madrigalForBabies.p28')" />
        </ul>
        <p v-html="$t('madrigalForBabies.p29')" />
        <p v-html="$t('madrigalForBabies.p30')" />
        <ul>
            <li class="font-weight-bold mt-4" v-html="$t('madrigalForBabies.p31')" />
        </ul>
        <p v-html="$t('madrigalForBabies.p32')" />
        <p v-html="$t('madrigalForBabies.p33')" />
        <img class="mb-0" src="../assets/images/madrigal-for-babies/babies_03.jpg" alt="Conductor explaining"/>
      </div>
      <div id="guide-for-parents">
        <p class="section-heading" v-html="$t('madrigalForBabies.p34')" />
        <div class="underline-bar"></div>
        <p v-html="$t('madrigalForBabies.p35')" />
        <ul>
            <li v-html="$t('madrigalForBabies.p36')" />
            <li v-html="$t('madrigalForBabies.p37')" />
            <li v-html="$t('madrigalForBabies.p38')" />
            <li v-html="$t('madrigalForBabies.p39')" />
        </ul>
      </div>
    </div>
  </div>
</template>
    
<script>
  import TextHeader from "./TextHeader";    
  export default {
    name: "MadrigalForBabies",
    components: { TextHeader },
    data() {}
  }
</script>
    
<style scoped lang="scss">
  #content {
    font-family: Fira Sans,sans-serif;
    font-size: 1.3em;
    line-height: 25px;
    font-weight: 400;
    padding: 60px 0;
  }

  @media screen and (max-width: 1155px) {
    #content {
      padding: 60px 7px;
    }
  }
  .paragraph-1 {
    font-size: 2em;
    line-height: 45px;
    margin-bottom: 45px;
    font-weight: 600;
    font-style: italic;
  }

  .section-heading {
    font-size: 1.6em;
    line-height: 45px;
    margin-bottom: 10px;
    margin-top: 50px;
  }

  .subheading {
    margin-bottom: 18px;
    font-size: 1.4em;
  }

  .underline-bar {
    background-color: #333;
    height: 3px;
    width: 120px;
    margin-bottom: 20px;
  }

  li {
    margin-bottom: 10px;
  }

  img {
    margin-top: 20px;
    margin-bottom: 30px;
  }

</style>
    